import React, {useCallback, useEffect, useState} from "react";
import {BiPlus} from "react-icons/bi";
import {FiSearch} from "react-icons/fi";
import {Link, useHistory, useParams, useRouteMatch} from "react-router-dom";
import BlockCustomDialog from "./BlockCustomDialog";
import {useMutation} from "react-query";
import {createTeacherPlayList, getRecentPlayList, searchByTitle} from "../../api/playlist";
import moment from "moment";
import {useKeycloak} from "@react-keycloak/web";
import _ from "lodash";
import {IoIosCloseCircleOutline} from "react-icons/io";
import {useDispatch} from "react-redux";

export default function BlockAddQuestionContent() {
    const history = useHistory();
    const {keycloak} = useKeycloak();
    const dispatch = useDispatch();
    const [searching, setSearching] = useState(false);
    const [isOpen, setOpen] = useState(false);
    const [playListTitle, _playListTitle] = useState('');
    const [searchTitle, _searchTitle] = useState('');
    const [playlistData, _playlistData] = useState([]);
    const [errorMsg, _errorMsg] = useState('');
    const {url} = useRouteMatch();
    const param = useParams();
    const [page, setPage] = useState(1);
    const ClassId = param.classId;

    /** fetch the added content data*/
    const fetchRecentlyAddedContent = () => {
        getRecentPlayList().then(res => {
            const playList = res?.data?.body;
            if (playList?.length > 0) {
                _playlistData(playList)
            }
        }).catch(error => console.log("Fetch Error to Recentally add Content"));
    }

    /** get the recently added content data*/
    useEffect(() => {
        fetchRecentlyAddedContent();
    }, []);

    /** create the teacher playlist start*/
    const {
        isLoading: isCreating,
        error: createError,
        isError: isCreateError,
        mutate,
        data
    } = useMutation(createTeacherPlayList, {
        onSuccess: (data, variables) => {
            if (data?.status === 201) {
                const playlistData = data.data.body;
                const id = playlistData.id;
                const title = playlistData.title;
                history.push({
                    pathname: `${url}/playlist`,
                    state: {
                        id: id,
                        title: title
                    }
                })
            }
        },
        onError: (err) => {
            _errorMsg('play list Already Exist');
            console.log("Error", err);
        },
    });

    /** Function used to add the new playlist */
    let insertPayList = () => {
        if (playListTitle.trim() !== '') {
            const start_time = moment().unix();
            const payload = {
                "id": ClassId,
                "title": playListTitle,
                "description": "string",
                "teacher_id": keycloak?.idTokenParsed?.sid,
                "createdOn": start_time,
                "modifiedOn": 0,
                "content": []
            }
            mutate(payload);
        } else {
            _errorMsg("Please Enter Question Title");
        }
    }

    const changeHandler = event => {
        const title = event.target.value;
        _searchTitle(title);
        if (title.trim() !== '') {
            searchByTitle(title).then((res) => {
                const playList = res.data.body;
                _playlistData(playList)
            }).catch(error => console.log("Error", error));
        } else {
            _playlistData(playlistData);
        }
    };


    /** debounce function used to submit the search value after some delay*/
    const debouncedChangeHandler = useCallback(_.debounce(changeHandler, 300), []);

    
    /** fetch the playlist data on scroll of div*/
    const scrollingDiv = (e) => {
        const {
            scrollTop,
            scrollHeight,
            clientHeight
        } = e.currentTarget;

        if (scrollHeight - scrollTop === clientHeight) {
            setPage((pre) => pre + 1);
        }
    }

    return (
        <>
            <div className="flex item-center border-b border-b-black gap-x-2">
                {searching ? (
                    <input
                        type="text"
                        className="bg-transparent w-full px-4 outline-0"
                        placeholder="Search"
                        onChange={debouncedChangeHandler}
                    />
                ) : (
                    <h4 className="text-xl flex-auto cursor-pointer" onClick={() => setSearching(true)}>Search</h4>
                )}
                <FiSearch
                    size={20}
                    className="cursor-pointer"
                    onClick={() => setSearching(true)}
                />
                <BiPlus
                    size={20}
                    className="cursor-pointer"
                    onClick={() => setOpen(true)}
                />
            </div>

            <div className="flex flex-col flex-auto justify-between">
                <div className="flex-auto" id="playListSection">
                    <h4 className="text-xl my-3">Question set_1</h4>
                    <div className="questionSelection">
                        <div>
                            <span>Select the type of MCQ</span>
                        </div>
                        <div>
                            <div>
                                <input
                                    name="selectQuestion"
                                    id="selectQuestion"
                                    type="radio"
                                />
                                <span className="ml-2">True/False</span>
                            </div>
                            <div>
                                <input
                                    name="selectQuestion"
                                    id="selectQuestion"
                                    type="radio"
                                />
                                <span className="ml-2">Fill Up</span>
                            </div>
                        </div>
                    </div>

                    {/*TODO : create the true false select question UI */}
                    <div className="questionSection">
                        <span className="text-xl text-black font-normal">True/False</span>
                        <div>
                            <span>1</span>
                            <div>
                                <div>
                                    <span>Is Earth the third planet </span>
                                </div>
                                <div>
                                    <div>
                                        sasas
                                    </div>
                                    <div>
                                        asasasa
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-between items-center">
                    <button
                        onClick={insertPayList}
                        className="w-30 px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                        Add
                    </button>
                    <Link to={`${url}/playlists`} className="ml-auto text-sm underline">View playlists</Link>
                </div>

            </div>

            <BlockCustomDialog
                targetId="contentWrapperBox"
                open={isOpen}
                onClose={() => setOpen(false)}
                overlayClasses="justify-center items-center backdrop-blur-md"
            >
                <div className="w-96 flex flex-col rounded-full p-4">
                    <h4 className="text-xl text-center font-medium">
                        {errorMsg !== '' ?
                            <div className="flex justify-between items-center">
                                <span className="text-red-600">{errorMsg}</span>
                                <IoIosCloseCircleOutline onClick={() => _errorMsg('')} className="cursor-pointer"/>
                            </div> : <span>Create New Question Set</span>}
                    </h4>
                    <div className="mb-6">
                        <input
                            type="text"
                            placeholder="Give your set a name"
                            className="text-sm text-center w-full bg-neutral-100 py-4 px-2 my-2 not-italic"
                            onChange={(e) => _playListTitle(e.target.value)}
                        />
                    </div>
                    <button onClick={insertPayList}
                            className="w-30 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                        Create
                    </button>
                </div>
            </BlockCustomDialog>
        </>
    );
}
